import React from "react";
import { useTranslation } from "react-i18next";
import OptimizedImage from "../components/image-optimization/OptimizedImage";
import StarRating from "../components/StarRating";

type SliderItemProps = {
  backgroundImage: string;
  overlayDark: number;
  title: string;
  subtitle: string;
  buttonText: string;
  isFirst?: boolean;
};

const SliderItem: React.FC<SliderItemProps> = ({
  backgroundImage,
  overlayDark,
  title,
  subtitle,
  buttonText,
  isFirst = false,
}) => {
  return (
    <div
      className="text-center item bg-img"
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Optimized background image */}
      <OptimizedImage
        src={backgroundImage}
        alt={title}
        loading={isFirst ? "eager" : "lazy"}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      />

      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          opacity: overlayDark * 0.1,
          zIndex: 1,
        }}
      />

      {/* Content */}
      <div className="v-middle caption">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <StarRating rating={"3"} />
              <h4>{subtitle}</h4>
              <h1>{title}</h1>
              <div className="butn-light mt-30 mb-30">
                <a href="#" data-scroll-nav="1">
                  <span>{buttonText}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Reservation: React.FC<{ phone: string; reservation: string }> = ({
  phone,
  reservation,
}) => {
  return (
    <div className="reservation">
      <a href={`tel:${phone}`}>
        <div className="icon d-flex justify-content-center align-items-center">
          <i className="flaticon-call"></i>
        </div>
        <div className="call">
          <span>{phone}</span> <br />
          {reservation}
        </div>
      </a>
    </div>
  );
};

const SliderSection: React.FC = () => {
  const { t: tHome } = useTranslation("home");
  const { t: tContact } = useTranslation("contact");

  const phone = tContact("phone.number");
  const reservation = tHome("slider.reservation");

  const sliderItems = [
    {
      title: tHome("slider.slider1.title"),
      subtitle: tHome("slider.subtitle"),
    },
    {
      title: tHome("slider.slider2.title"),
      subtitle: tHome("slider.subtitle"),
    },
    {
      title: tHome("slider.slider3.title"),
      subtitle: tHome("slider.subtitle"),
    },
  ];

  return (
    <header className="header slider-fade">
      <div className="owl-carousel owl-theme">
        {sliderItems.map((item, index) => (
          <SliderItem
            key={index}
            backgroundImage={`/images/slider/${index + 1}.jpg`}
            overlayDark={3}
            title={item.title}
            subtitle={item.subtitle}
            buttonText={tHome("slide.buttonText")}
            isFirst={index === 0} // Mark first slide for LCP optimization
          />
        ))}
      </div>
      <Reservation phone={phone} reservation={reservation} />
    </header>
  );
};

export default SliderSection;
